var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "upcoming-events container" }, [
    _c(
      "div",
      { staticClass: "upcoming-events-wrapper" },
      [
        _c("upcoming-events-list", {
          ref: "eventList",
          attrs: {
            "server-items": _vm.availableEvents,
            variant: "upcoming-events",
          },
          scopedSlots: _vm._u([
            {
              key: "filter",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "upcoming-events-header" },
                    [
                      _c("div", { staticClass: "range-date-filter form" }, [
                        _c(
                          "div",
                          { staticClass: "input date-range" },
                          [
                            _c("date-range-field-input", {
                              ref: "dateRangeField",
                              attrs: {
                                lang: _vm.calendarLang,
                                "min-date": _vm.todaysDate,
                                "max-date": _vm.oneYearLaterDate,
                                "available-dates": _vm.availableDates,
                              },
                              on: { "date-change": _vm.handleDateChange },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var toggleCalendar = ref.toggleCalendar
                                    var resultLabel = ref.resultLabel
                                    return [
                                      _c("input", {
                                        attrs: {
                                          id: "range-date-events",
                                          type: "text",
                                          name: "range-date-events",
                                          max: _vm.oneYearLaterDate,
                                          "data-field-type": "DateField",
                                          readonly: "",
                                        },
                                        domProps: { value: resultLabel },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return toggleCalendar($event)
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "floating",
                                          class: resultLabel ? "" : "no-result",
                                          attrs: { for: "range-date-events" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                resultLabel
                                                  ? _vm.tc("calendar.dateRange")
                                                  : _vm.tc(
                                                      "calendar.selectDateRange"
                                                    )
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("button", {
                                        staticClass: "icon-calendar",
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return toggleCalendar($event)
                                          },
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.showEventsFilter
                        ? _c("upcoming-events-filter", {
                            ref: "upcomingEventsFilter",
                            attrs: {
                              events: _vm.sortedEvents,
                              "date-range": _vm.selectedDates,
                              settings: _vm.settings,
                              dictionary: _vm.dictionary,
                            },
                            on: {
                              updateFilteredEvents: _vm.updateAvailableEvents,
                              resetDateRange: _vm.handleResetDateRange,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var activate = ref.activate
                                    var isActive = ref.isActive
                                    var resetAllFilters = ref.resetAllFilters
                                    var totalFiltersSelected =
                                      ref.totalFiltersSelected
                                    return _c(
                                      "button",
                                      {
                                        staticClass:
                                          "filter-sidebar--activator",
                                        class: totalFiltersSelected
                                          ? "filter-selected"
                                          : "",
                                        on: { click: activate },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "filter-sidebar--activator-label",
                                            class: totalFiltersSelected
                                              ? "filter-selected"
                                              : "",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.dictionary[
                                                  "upcoming-events:filter"
                                                ]
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        totalFiltersSelected > 0
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "filter-sidebar--activator-total-tag",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(totalFiltersSelected)
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "icon-filter-black",
                                        }),
                                        _vm._v(" "),
                                        totalFiltersSelected > 0
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "filter-sidebar--activator-reset",
                                                attrs: {
                                                  tabindex: isActive
                                                    ? "-1"
                                                    : "0",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return resetAllFilters(
                                                      $event
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.dictionary[
                                                        "upcoming-events:reset"
                                                      ]
                                                    ) +
                                                    "\n              "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  },
                                },
                              ],
                              null,
                              false,
                              3208668062
                            ),
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "no-items",
              fn: function () {
                return [
                  _c("div", { staticClass: "error-box no-margin" }, [
                    _c("span", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.dictionary["upcoming-events:no-result-message"]
                          ) +
                          "\n          "
                      ),
                    ]),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "card-template",
              fn: function (ref) {
                var item = ref.item
                var key = ref.key
                return [
                  _c("event-card", {
                    key: key,
                    attrs: { event: item, dictionary: _vm.dictionary },
                  }),
                ]
              },
            },
            {
              key: "pagination",
              fn: function (ref) {
                var pagination = ref.pagination
                var defaultLimit = ref.defaultLimit
                var allLoaded = ref.allLoaded
                return [
                  _c(
                    "div",
                    { staticClass: "pagination" },
                    [
                      _c(
                        "load-more-pagination",
                        _vm._b(
                          {
                            attrs: {
                              variant: "upcoming-events",
                              "load-more-text":
                                _vm.dictionary["upcoming-events:load-more"],
                            },
                            model: {
                              value: pagination,
                              callback: function ($$v) {
                                pagination = $$v
                              },
                              expression: "pagination",
                            },
                          },
                          "load-more-pagination",
                          { defaultLimit: defaultLimit, allLoaded: allLoaded },
                          false
                        )
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }